import React, { useEffect } from 'react';
import ConnectedGreetingBanner from './ConnectedGreetingBanner';
import ConnectedContributors from './ConnectedTopContributors';
import ConnectedTopTags from './ConnectedTopTags';
import ConnectedPieces from './ConnectedPieces';
import ConnectedActivity from './ConnectedActivityCalendar';
// import ConnectedMap from '../../map/ConnectedMap';
// import ConnectedImpactCard from '../../map/ImpactCard';
import ErrorBoundary from '../../common/ErrorBoundary';
import './styles.scss';

function Dashboard() {
    // scroll top top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <div className="col-12">
                <ConnectedGreetingBanner />
            </div>
            <div className="spacer"></div>
            <div className="row dashboard">
                <div className="col-md-5 d-flex flex-column">
                    <div className="row">
                        <div className="col">
                            <ConnectedPieces />
                        </div>
                    </div>
                    <div className="spacer"></div>
                    <div className="row flex-grow-1">
                        <div className="col topContributorsCol">
                            <ErrorBoundary>
                                <ConnectedContributors />
                            </ErrorBoundary>
                        </div>
                    </div>
                    <div className="spacer"></div>
                </div>
                <div className="col-md-7">
                    <div className="row">
                        <div className="col">
                            <ErrorBoundary>
                                <ConnectedActivity />
                            </ErrorBoundary>
                        </div>
                    </div>
                    <div className="spacer"></div>
                    <div className="row">
                        <div className="col pieGraphCol">
                            <ErrorBoundary>
                                <ConnectedTopTags />
                            </ErrorBoundary>
                        </div>
                    </div>
                    <div className="spacer"></div>
                </div>
                {/* <div className="col-md-12 mapWrapper">
                    <ErrorBoundary>
                        <ConnectedMap />
                    </ErrorBoundary>
                    <div className="impact-container">
                        <ErrorBoundary>
                            <ConnectedImpactCard />
                        </ErrorBoundary>
                    </div>
                </div> */}
            </div>
        </div>
    );
}
export default Dashboard;
